(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.hyperappLogger = {})));
}(this, (function (exports) { 'use strict';

function defaultLog(prevState, action, nextState) {
  console.group("%c action", "color: gray; font-weight: lighter;", action.name);
  console.log("%c prev state", "color: #9E9E9E; font-weight: bold;", prevState);
  console.log("%c data", "color: #03A9F4; font-weight: bold;", action.data);
  console.log("%c next state", "color: #4CAF50; font-weight: bold;", nextState);
  console.groupEnd();
}

var isFn = function(value) {
  return typeof value === "function"
};

function makeLoggerApp(log, nextApp) {
  return function(initialState, actionsTemplate, view, container) {
    function enhanceActions(actions, prefix) {
      var namespace = prefix ? prefix + "." : "";
      return Object.keys(actions || {}).reduce(function(otherActions, name) {
        var namedspacedName = namespace + name;
        var action = actions[name];
        otherActions[name] =
          typeof action === "function"
            ? function(data) {
                return function(state, actions) {
                  var result = action(data);
                  result =
                    typeof result === "function"
                      ? result(state, actions)
                      : result;
                  log(state, { name: namedspacedName, data: data }, result);
                  return result
                }
              }
            : enhanceActions(action, namedspacedName);
        return otherActions
      }, {})
    }

    var enhancedActions = enhanceActions(actionsTemplate);

    var appActions = nextApp(initialState, enhancedActions, view, container);
    return appActions
  }
}

function withLogger(optionsOrApp) {
  if (isFn(optionsOrApp)) {
    return makeLoggerApp(defaultLog, optionsOrApp)
  } else {
    var log = isFn(optionsOrApp.log) ? optionsOrApp.log : defaultLog;
    return function(nextApp) {
      return makeLoggerApp(log, nextApp)
    }
  }
}

exports.withLogger = withLogger;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=hyperappLogger.js.map
